@if (disabled) {
    <div class="w-full readonly-banner flex justify-around mb-1">You are in a read only view.  Contact your admin to make changes to intent settings.</div>
}
@if (!isLoading) {
    <div class="flex flex-wrap">
        @if (!recommendationMode) {
            <div class="flex-none w-full">
                <div class="intent-plan-banner">
                    <div class="intent-plan-banner__plans flex flex-wrap items-center">
                        @for (plan of plans; track $index) {
                            <span class="mr-8 whitespace-nowrap">
                                <span class="font-bold">{{plan.label}}: </span>
                                <span>{{ $index === 0 ? plan.value : (plan.value | number) }}</span>
                            </span>
                        }
                    </div>
                    @if (!disabled) {
                        <div class="mt-1">
                            Select up to {{planPropertyValues?.maxTopics | number}} topics that can be used by your team.
                            @if (showGetRecommendations) {
                                <a class="a ml-1" (click)="onGetRecommendations()">Get recommendations.</a>
                            }
                        </div>
                    }
                </div>
            </div>
        }
    </div>
} @else {
    <div class="flex flex-wrap -mx-2">
        <div class="flex-none w-full my-12 px-2">
            <article class="flex justify-center">
                <mat-spinner></mat-spinner>
            </article>
        </div>
    </div>
}

<!-- Main-view headers only; in recommendation mode the wizard band renders this row. -->
@if (!recommendationMode) {
    <div class="flex flex-wrap mt-4">
        <div class="flex-none w-1/2 pr-2 intent-col-divider">
            <h4 class="font-bold">
                Available topics ({{topics | intentDataTopicCount | number}})
            </h4>
            <div class="flex justify-start py-1">
                <p class="mb-1 mr-2">Filter by:</p>
                <mat-radio-group [(ngModel)]="filterIntentType">
                    <mat-radio-button class="mr-2" value="categories">Categories</mat-radio-button>
                    <mat-radio-button value="topics">Topics</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
        <div class="flex-none w-1/2 pl-2">
            <h4 class="font-bold">
                Your topics ({{existingTopics?.length | number}})
                <span class="a float-right font-normal" (click)="removeAll()" [ngClass]="{disable: disabled}">Remove All</span>
            </h4>
        </div>
    </div>
}

<div class="flex flex-wrap intent-section" [class.intent-section--rec]="recommendationMode">
    <div class="flex-none w-1/2 pr-2 intent-col-divider">
        @if (!recommendationMode) {
            <mat-form-field appearance="outline" class="mb-2 w-full no-padding">
                <mat-label>Filter by {{filterIntentType === 'categories' ? 'category' : 'topic'}}</mat-label>
                <input matInput type="text" placeholder="Filter by {{filterIntentType === 'categories' ? 'category' : 'topic'}}" [(ngModel)]="searchAvailableTopic">
                <fa-icon class="mat-primary si-icon" matSuffix [icon]="['fal', 'magnifying-glass']"></fa-icon>
            </mat-form-field>
        }

        <div class="border rounded overflow-hidden bg-white list-box">
            <mat-list class="list-topics">
                @if (topics?.length) {
                    <cdk-virtual-scroll-viewport itemSize="48">
                        <ng-container *cdkVirtualFor="let topic of topics | topicsFilter: searchAvailableTopic : filterIntentType | collapsedCategoriesFilter: collapsedCategories">
                            @if (topic.category) {
                                <!-- Category labels: click to collapse/expand the topics under them. -->
                                <mat-list-item
                                    class="intent-topic-item category-name bg-tab font-bold cursor-pointer"
                                    [ngClass]="{ disable: disabled }"
                                    (click)="toggleCategory(topic.category)"
                                >
                                    <div class="flex justify-between items-center w-full">
                                        <span class="block">{{topic.category}}</span>
                                        <fa-icon class="text-dark py-0 ml-2" [icon]="['fas', collapsedCategories.has(topic.category) ? 'chevron-down' : 'chevron-up']"></fa-icon>
                                    </div>
                                </mat-list-item>
                            } @else {
                                <button
                                    mat-list-item
                                    type="button"
                                    class="intent-topic-item cursor-pointer"
                                    [disabled]="disabled"
                                    [ngClass]="{ disable: disabled }"
                                    (click)="addTopic(topic)"
                                >
                                    <div class="list-group-item__wrapper flex justify-between items-center">
                                        <span class="truncate list-group-item__text">{{topic.topic_name}}</span>
                                        @if (!existingTopicsAcc?.[topic.topic_id]) {
                                            <fa-icon class="text-dark py-0 ml-2" [icon]="['fas', 'plus']"></fa-icon>
                                        } @else {
                                            <fa-icon class="text-success py-0 ml-2" [icon]="['fas', 'check']"></fa-icon>
                                        }
                                    </div>
                                </button>
                            }
                        </ng-container>
                    </cdk-virtual-scroll-viewport>
                } @else {
                    <mat-list-item class="flex justify-between items-center break-words py-2">
                        No Topics Found
                    </mat-list-item>
                }
            </mat-list>
        </div>
    </div>

    <div class="flex-none w-1/2 pl-2">
        @if (recommendationMode) {
            <h4 class="font-bold mb-2">
                Your topics ({{existingTopics?.length | number}})
            </h4>
        }
        @if (!recommendationMode) {
            <mat-form-field appearance="outline" class="mb-2 w-full no-padding">
                <mat-label>Filter by topic</mat-label>
                <input matInput type="text" placeholder="Filter by topic" [(ngModel)]="searchYourTopic">
                <fa-icon class="mat-primary si-icon" matSuffix [icon]="['fal', 'magnifying-glass']"></fa-icon>
            </mat-form-field>
        }
        <div class="border rounded overflow-hidden bg-white list-box">
            <mat-list class="list-topics">
                @for (topic of existingTopics | existingTopicsFilter: searchYourTopic | orderBy : 'topic_name'; track topic.topic_id) {
                    <mat-list-item
                        class="break-words py-2"
                        [disabled]="disabled"
                        [ngClass]="{disable: disabled}">
                        <div class="flex justify-between items-center w-full">
                        <span class="truncate">{{topic.topic_name}}</span>
                        <button
                            matIconButton
                            class="mat-error"
                            type="button"
                            title="Delete"
                                [disabled]="disabled"
                            (click)="deleteTopic(topic)"
                        >
                            <fa-icon class="si-icon" [icon]="['fal', 'trash-can']"></fa-icon>
                        </button>
                        </div>
                    </mat-list-item>
                }
                @if (!existingTopics?.length) {
                    <mat-list-item class="flex justify-between items-center break-words py-2">
                        No Topics Found
                    </mat-list-item>
                }
            </mat-list>
        </div>
    </div>
</div>
